import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ServicesIcon } from '../../variables/dataIcons';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import { connect } from 'react-redux';
import { toZar } from '../../helpers';
import { Edit } from '@material-ui/icons';
import { Fab, IconButton, withStyles } from '@material-ui/core';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import EditableLabel from '../../components/CustomInput/EditableLabel';

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import ServiceEndpoints from '../../api/ServiceEndpoints';
import NumberMaskInput from '../../components/CustomInput/NumberMaskInput';
import CustomInput from '../../components/CustomInput/CustomInput';

class ViewService extends Component {

    constructor(props) {
        super(props);

        var currentService = props.allServices.find(x => x.id == props.match.params.service_id);

        console.log(currentService);

        this.state = {
            service_id: props.match.params.service_id,
            service: currentService || {},
            company: currentService.cost_center || '',
            provider: currentService.provider || '',
            providerState: '',
            name: currentService.name,
            nameState: '',
            stock_code: currentService.stock_code,
            stock_codeState: '',
            cost: currentService.cost.cost,
            costFormatted: toZar(currentService.cost.cost),
            costState: ''
        }
    }

    changeNum(e, name) {
        this.setState({ [name]: e.target.floatValue, [name + "Formatted"]: e.target.formattedValue, [name + "State"]: (e.target.formattedValue ? "success" : "error") });
    }

    render() {
        const { classes } = this.props;

        return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                    <Card profile>
                        <CardAvatar style={{ marginTop: -40 }}>
                            <FontAwesomeIcon icon={ServicesIcon} size="6x" />
                        </CardAvatar>
                        <CardBody profile>
                            <EditableLabel
                                label={<h3 style={{ marginTop: 0 }}>{this.state.service.name}</h3>}
                                editValue={{ service_id: parseInt(this.state.service_id), name: this.state.name }}
                                endpoint={ServiceEndpoints.editName}
                                onSubmitSuccess={(data) => this.setState({ service: { ...this.state.service, name: data } })}
                                noIcon
                            >
                                <CustomInput
                                    success={this.state.nameState === "success"}
                                    error={this.state.nameState === "error"}
                                    id="name"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        onChange: event => this.setState({ name: event.target.value, nameState: event.target.value ? "success" : "error" }),
                                        value: this.state.name,
                                    }}
                                />
                            </EditableLabel>
                            <EditableLabel
                                label={<h4>{this.state.service.stock_code}</h4>}
                                editValue={{ service_id: parseInt(this.state.service_id), stock_code: this.state.stock_code }}
                                endpoint={ServiceEndpoints.editStockCode}
                                onSubmitSuccess={(data) => this.setState({ service: { ...this.state.service, stock_code: data } })}
                                noIcon
                            >
                                <CustomInput
                                    success={this.state.stock_codeState === "success"}
                                    error={this.state.stock_codeState === "error"}
                                    id="stock_code"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        onChange: event => this.setState({ stock_code: event.target.value, stock_codeState: event.target.value ? "success" : "error" }),
                                        value: this.state.stock_code,
                                    }}
                                />
                            </EditableLabel>
                            <GridContainer>
                                <GridItem xs={6} style={{ textAlign: 'left', fontWeight: 'bold', display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                    Provider:
                                </GridItem>
                                <GridItem xs={6} style={{ textAlign: 'right' }}>
                                    <EditableLabel
                                        label={this.state.service.provider}
                                        editValue={{ service_id: parseInt(this.state.service_id), provider: this.state.provider }}
                                        endpoint={ServiceEndpoints.editProvider}
                                        onSubmitSuccess={(data) => this.setState({ service: { ...this.state.service, provider: data } })}
                                    >
                                        <CustomInput
                                            success={this.state.providerState === "success"}
                                            error={this.state.providerState === "error"}
                                            id="provider"
                                            formControlProps={{
                                                style: {
                                                    textAlign: 'left',
                                                    width: '50%',
                                                    paddingTop: 0,
                                                    marginBottom: 0
                                                }
                                            }}
                                            inputProps={{
                                                onChange: event => this.setState({ provider: event.target.value, providerState: event.target.value ? "success" : "error" }),
                                                value: this.state.provider,
                                            }}
                                        />
                                    </EditableLabel>
                                </GridItem>
                                <GridItem xs={6} style={{ textAlign: 'left', fontWeight: 'bold', display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                    Cost Center:
                                </GridItem>
                                <GridItem xs={6} style={{ textAlign: 'right' }}>
                                    <EditableLabel
                                        label={this.state.service.cost_center}
                                        editValue={{ service_id: parseInt(this.state.service_id), company: this.state.company }}
                                        endpoint={ServiceEndpoints.editCostCenter}
                                        onSubmitSuccess={(data) => this.setState({ service: { ...this.state.service, cost_center: data } })}
                                    >
                                        <Select
                                            //fullWidth
                                            MenuProps={{
                                                className: classes.selectMenu
                                            }}
                                            classes={{
                                                select: classes.select
                                            }}
                                            value={this.state.company}
                                            onChange={(event) => this.setState({ company: event.target.value })}
                                            inputProps={{
                                                name: "company",
                                                id: "company"
                                            }}
                                            color="rose"
                                            style={{ textAlign: 'left', width: '50%', paddingTop: 0, marginBottom: 0 }}
                                        >
                                            <MenuItem disabled classes={{ root: classes.selectMenuItem }}>Choose Company</MenuItem>
                                            <MenuItem
                                                classes={{
                                                    root: classes.selectMenuItem,
                                                    selected: classes.selectMenuItemSelected
                                                }}
                                                value="Cellfind"
                                            >
                                                Cellfind
                                            </MenuItem>
                                            <MenuItem
                                                classes={{
                                                    root: classes.selectMenuItem,
                                                    selected: classes.selectMenuItemSelected
                                                }}
                                                value="Panacea"
                                            >
                                                Panacea
                                            </MenuItem>
                                            <MenuItem
                                                classes={{
                                                    root: classes.selectMenuItem,
                                                    selected: classes.selectMenuItemSelected
                                                }}
                                                value="Simigenix"
                                            >
                                                Simigenix
                                            </MenuItem>
                                        </Select>
                                    </EditableLabel>
                                    {/* {this.state.service.cost_center} <IconButton><Edit /></IconButton> */}
                                </GridItem>
                                <GridItem xs={6} style={{ textAlign: 'left', fontWeight: 'bold', display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                    Cost:
                                </GridItem>
                                <GridItem xs={6} style={{ textAlign: 'right' }}>
                                    <EditableLabel
                                        label={toZar(this.state.service.cost.cost)}
                                        editValue={{ service_id: parseInt(this.state.service_id), cost: this.state.cost }}
                                        endpoint={ServiceEndpoints.editCost}
                                        onSubmitSuccess={(data) => this.setState({ service: { ...this.state.service, cost: data } })}
                                    >
                                        <NumberMaskInput
                                            success={this.state.costState === "success"}
                                            error={this.state.costState === "error"}
                                            id="cost"
                                            formControlProps={{
                                                style: {
                                                    textAlign: 'left',
                                                    width: '50%',
                                                    paddingTop: 0,
                                                    marginBottom: 0
                                                }
                                            }}
                                            inputProps={{
                                                onChange: event => this.changeNum(event, 'cost'),
                                                value: this.state.costFormatted
                                            }}
                                        />
                                    </EditableLabel>
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        {/* Edit Dialog */}

                    </Card>
                </GridItem>
            </GridContainer>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        allServices: state.services.list
    };
}

export default withStyles(extendedFormsStyle)(connect(mapStateToProps)(ViewService));
